import React from "react";

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
  showInfoIcon?: boolean;
  infoIconSrc?: string;
}

const Toggle: React.FC<ToggleProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  className = "",
  showInfoIcon = false,
  infoIconSrc,
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        <div className={`relative w-11 h-6 bg-[#F1F1F2] peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white peer-checked:after:bg-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-[#F0E3E0] after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-orange ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}></div>
      </label>
      {label && <p className="mx-2 text-sm text-nowrap">{label}</p>}
      {showInfoIcon && infoIconSrc && (
        <img src={infoIconSrc} alt="" width={15} height={15} />
      )}
    </div>
  );
};

export default Toggle;

